import { GetTransferRequestsProps } from "@/services/transfer-requests.service";
import dayjs, { Dayjs } from "dayjs";

export interface TRFRProps {
  request_date?: Dayjs;
  account_owner: string;
  sucursal: number[];
  request_amount: string;
  requester: string;
  request_type: string[];
  origin_account: string;
  destiny_account: string;
  estado?: string[];
}

export const getTransferRequestFilter = (
  event: TRFRProps,
): Partial<GetTransferRequestsProps> => {
  let amount;

  if (event?.request_amount) {
    const cleaned = event?.request_amount
      .replaceAll(/[^0-9,.-]/g, "")
      .replaceAll(".", "")
      .replaceAll(",", ".");

    amount = Number.parseFloat(cleaned).toFixed(2);
  }

  return {
    ...(event?.request_date && dayjs(event?.request_date).isValid()
      ? {
          Fecha: dayjs(event?.request_date).toISOString(),
        }
      : {}),
    ...(event?.estado?.length
      ? {
          estado: event?.estado,
        }
      : {}),
    ...(event?.account_owner
      ? {
          titular: event?.account_owner,
        }
      : {}),
    ...(event?.origin_account
      ? {
          nroCuenta: event?.origin_account,
        }
      : {}),
    ...(event?.destiny_account
      ? {
          cuentaDestino: event?.destiny_account,
        }
      : {}),
    ...(event?.request_amount && amount
      ? {
          monto: Number(amount),
        }
      : {}),
    ...(event?.requester
      ? {
          solicitante: event?.requester,
        }
      : {}),
  };
};
